var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarChevronRight = function SvgCalendarChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "calendarChevronRight_svg__a",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#calendarChevronRight_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "m25.892 24-8.147-8.146a1.45 1.45 0 0 1-.425-1.044 1.42 1.42 0 0 1 .425-1.064q.435-.434 1.054-.434.62 0 1.054.434l8.988 8.989q.282.28.396.592.117.312.116.673 0 .361-.116.673a1.7 1.7 0 0 1-.395.593l-8.989 8.988a1.45 1.45 0 0 1-1.045.425 1.42 1.42 0 0 1-1.063-.425 1.44 1.44 0 0 1-.434-1.054q0-.62.434-1.054z"
  }))));
};
export default SvgCalendarChevronRight;